import { isDefined } from "@clipboard-health/util-ts";
import { type SxProps, type Theme } from "@mui/material";

import { MESSAGE_CUSTOM_TYPES } from "../constants";
import type { AdminChatMessage } from "../types";
import { parseShiftTimeProposalMessageData } from "../utils/parseShiftTimeProposalMessage";
import { ShiftTimeProposalCreatedMessage } from "./ShiftTimeProposalCreatedMessage";

interface ShiftTimeProposalMessageRouterProps {
  message: AdminChatMessage;
  sx?: SxProps<Theme>;
}

/**
 * Routes shift time proposal messages to the appropriate display component.
 * Parses the message data and renders the ShiftTimeProposalCreatedMessage component.
 * Returns null if the message is not a SHIFT_TIME_PROPOSAL_CREATED or if data parsing fails.
 */
export function ShiftTimeProposalMessageRouter(
  props: ShiftTimeProposalMessageRouterProps
): React.ReactElement | null {
  const { message, sx } = props;

  if (message.customType !== MESSAGE_CUSTOM_TYPES.SHIFT_TIME_PROPOSAL_CREATED) {
    return null;
  }

  const parsedData = parseShiftTimeProposalMessageData(message.data);

  // Don't render if data is missing required fields
  if (!isDefined(parsedData)) {
    return null;
  }

  return (
    <ShiftTimeProposalCreatedMessage
      originalEndTime={parsedData.originalEndTime}
      originalStartTime={parsedData.originalStartTime}
      shiftTimeProposalId={parsedData.shiftTimeProposalId}
      sx={sx}
    />
  );
}
